import type {
    RoundtripStageMiddlewareRequest,
    RoundtripStageMiddlewareResponse,
} from '../types/roundtrip-stage-middleware.types';

function resolveBaseUrl(): string {
    return import.meta.env.VITE_ROUNDTRIP_STAGE_SERVICE_URL ?? 'http://localhost:7071/api/roundtrip-stage';
}

function buildRoundtripStageMiddlewareUrl(request: RoundtripStageMiddlewareRequest): URL {
    const url = new URL(resolveBaseUrl());

    Object.entries(request).forEach(([key, value]) => {
        if (typeof value === 'string' && value.trim().length > 0) {
            url.searchParams.set(key, value);
        }
    });

    return url;
}

/**
 * Requests stage content from the middleware using validated query parameters.
 * @param request - Query parameters forwarded to the stage middleware endpoint.
 * @returns Middleware response payload for roundtrip stage content.
 */
export async function fetchRoundtripStageContent(
    request: RoundtripStageMiddlewareRequest
): Promise<RoundtripStageMiddlewareResponse> {
    const url = buildRoundtripStageMiddlewareUrl(request);
    const response = await fetch(url.toString());

    if (!response.ok) {
        throw new Error(`Failed to fetch roundtrip-stage content: ${response.status}`);
    }

    return (await response.json()) as RoundtripStageMiddlewareResponse;
}
